import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-shaweta',
  templateUrl: './shaweta.component.html',
  styleUrls: ['./shaweta.component.scss']
})
export class ShawetaComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getShaweta();
  }

}
